import styles from './styles.module.scss';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useIsInIframe } from 'features/notifications/hooks/use-is-in-Iframe';
import { FC } from 'react';

type Props = {
  showMessageType?: 'All' | 'Unread' | 'Read';
  setShowMassageType: (type: 'All' | 'Unread' | 'Read') => void;
  onClose: VoidFunction;
};

export const HeaderComponent: FC<Props> = ({ showMessageType = 'All', setShowMassageType, onClose }) => {
  const isInIframe = useIsInIframe();
  return (
    <div className={clsx(styles.container, isInIframe ? styles.frame : null)}>
      <div className={clsx(styles.title)}>Notifications</div>
      <div className={clsx(styles.tabContainer)}>
        <button
          type="button"
          className={clsx(showMessageType === 'All' && styles.active)}
          onClick={() => setShowMassageType('All')}
        >
          All
        </button>
        <button
          type="button"
          className={clsx(showMessageType === 'Unread' && styles.active)}
          onClick={() => setShowMassageType('Unread')}
        >
          Unread
        </button>
        <button
          type="button"
          className={clsx(showMessageType === 'Read' && styles.active)}
          onClick={() => setShowMassageType('Read')}
        >
          Read
        </button>
      </div>
      {!isInIframe && (
        <button type="button" onClick={() => onClose()} className={clsx(styles.btnClose)}>
          <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
        </button>
      )}
    </div>
  );
};
